import type { ComponentProps, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

export const Label: FC<ComponentProps<'label'>> = ({ className, ...props }): ReactNode => {
    return (
        <label
            className={cn('flex items-center gap-1.5 text-[13px] font-semibold text-foreground/90', className)}
            {...props}
        />
    )
}

type FieldProps = {
    label: ReactNode
    htmlFor?: string
    hint?: ReactNode
    error?: string | null
    optional?: boolean
    trailing?: ReactNode
    className?: string
    children: ReactNode
}

export const Field: FC<FieldProps> = ({
    label,
    htmlFor,
    hint,
    error,
    optional = false,
    trailing,
    className,
    children
}): ReactNode => {
    return (
        <div className={cn('flex min-w-0 flex-col gap-1.5', className)}>
            <div className='flex items-center justify-between gap-2'>
                <Label htmlFor={htmlFor}>
                    {label}

                    {optional && (
                        <span className='font-normal text-muted-foreground'>
                            (opsional)
                        </span>
                    )}
                </Label>

                {trailing}
            </div>

            {children}

            {error ? (
                <p className='text-xs font-medium text-destructive' role='alert'>
                    {error}
                </p>
            ) : hint ? (
                <p className='text-xs leading-relaxed text-muted-foreground'>
                    {hint}
                </p>
            ) : null}
        </div>
    )
}
